// extracted by mini-css-extract-plugin
module.exports = {"container":"e_I5","poster":"e_J5","player":"e_K5","play":"e_L5","playBadge":"e_M5","playIcon":"e_N5","loading":"e_O5","spin":"e_P5"};